import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import memoize from 'memoize-one';

import { indexSyndicatesRequest, deleteSyndicateRequest } from '../../requests/syndicates';
import { ComponentDataTable, DefaultModal, BasicActionBtns } from '../../components';
import { sendAlert } from '../../actions/utils';

const columns = memoize(clickHandler => [
  {
    name: 'CÓDIGO',
    selector: 'code',
    sortable: true,
    grow: '1'
  },
  {
    name: 'NOMBRE',
    selector: 'name',
    sortable: true,
    grow: '1'
  },
  {
    name: 'RUT',
    selector: 'identification_number',
    sortable: true,
    grow: '1'
  },
  {
    name: 'DIRECCIÓN',
    selector: 'address',
    cell: item => item.full_address,
    sortable: true,
    grow: '1'
  },
  {
    name: 'ACCIONES',
    cell: item => <BasicActionBtns item={item} resource="Syndicate" clickHandler={clickHandler} />,
    ignoreRowClick: true,
    allowOverflow: false,
    button: true,
    grow: '1',
    minWidth: '123px'
  }
]);

class SyndicateDataTable extends Component {
  state = {
    onRequest: true,
    syndicates: [],
    amount: 0,
    moreData: false,
    modalShow: false,
    modalItem: null,
    modalBody: '',
    disabled: false
  };

  handleRequest = async params => {
    const { dispatch } = this.props;
    this.setState({
      onRequest: true
    });
    indexSyndicatesRequest({
      dispatch,
      params,
      successCallback: this.handleSuccessIndex
    });
  };

  handleSuccessIndex = response => {
    const syndicates = response.data.data;
    const { amount } = response.data.metadata;
    this.setState({
      syndicates,
      amount,
      onRequest: false
    });
  };

  handleSuccessRemove = message => {
    const { moreData } = this.state;
    const { dispatch } = this.props;
    this.handleModalClose();
    dispatch(sendAlert({ kind: 'success', message }));
    this.setState({
      moreData: !moreData,
      onRequest: false,
      disabled: false
    });
  };

  removeSyndicate = syndicateId => {
    const { dispatch } = this.props;
    this.setState({
      disabled: true
    });
    deleteSyndicateRequest(syndicateId, {
      dispatch,
      successCallback: this.handleSuccessRemove('Sindicato Eliminado Correctamente')
    });
  };

  handleButtonClick = (item, action) => {
    const { history } = this.props;
    switch (action) {
      case 'show':
        history.push(`/syndicates/${item.id}`);
        break;
      case 'edit':
        history.push(`/syndicates/${item.id}/edit`);
        break;
      case 'destroy':
        this.setState({
          modalShow: true,
          modalItem: item,
          modalBody: '¿Estás seguro que deseas eliminar este sindicato?'
        });
        break;
      default:
        // eslint-disable-next-line no-console
        console.log('Error: Action not found');
        break;
    }
  };

  handleModalClose = () => {
    this.setState({
      modalShow: false
    });
  };

  handleModalConfirm = () => {
    const { modalItem } = this.state;
    this.removeSyndicate(modalItem.id);
  };

  render() {
    const { syndicates, amount, onRequest, moreData, modalShow, modalBody, disabled } = this.state;
    return (
      <>
        <ComponentDataTable
          onRequest={onRequest}
          columns={columns(this.handleButtonClick)}
          data={syndicates}
          totalRows={amount}
          moreData={moreData}
          resourceRequest={this.handleRequest}
          onRowClicked={item => this.handleButtonClick(item, 'show')}
          pointerOnHover
        />
        <DefaultModal
          title="Eliminar Sindicato"
          body={modalBody}
          show={modalShow}
          handleClose={this.handleModalClose}
          handleConfirm={this.handleModalConfirm}
          titleBtnClose="Cancelar"
          titleBtnSave="Confirmar"
          disabled={onRequest || disabled}
        />
      </>
    );
  }
}

export default withRouter(connect()(SyndicateDataTable));
